import Tooltip from '@/modules/drivers/shared/ToolTip'
import * as React from 'react'

export const TooltipOptional = ({
  tooltip,
  children,
  maxWidth,
  portal,
  zIndex,
}: {
  tooltip: string
  children: React.ReactNode
  /** Zawija dluzsza tresc zamiast rozciagac dymek w jedna linie poza ekran. */
  maxWidth?: string
  portal?: boolean
  zIndex?: number
}) =>
  tooltip ? (
    <Tooltip
      text={tooltip}
      asChild
      maxWidth={maxWidth}
      portal={portal}
      zIndex={zIndex}
    >
      {children}
    </Tooltip>
  ) : (
    <>{children}</>
  )
